module.exports = __webpack_public_path__ + "static/media/fleet.7dbbab94.svg";